import React from "react";
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { vs2015 } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { monokaiSublime } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { solarizedLight } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/hljs';

const App = () => {
  // Define the JSON data as a string to preserve comments
  const jsonString = `{
    "name": "John Doe", // Notation example
    "age": 30,
    "occupation": "Software Engineer",
    "address": {
      "street": "123 Main St",
      "city": "Anytown",
      "state": "CA",
      "zip": "12345"
    }
  }`;

  return (
    <div className="">

<p>vs2015</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={vs2015}>
        {jsonString}
      </SyntaxHighlighter>
    </div>


<p>docco</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={docco}>
        {jsonString}
      </SyntaxHighlighter>
    </div>

    <p>atomOneDark</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={atomOneDark}>
        {jsonString}
      </SyntaxHighlighter>
    </div>

    <p>github</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={github}>
        {jsonString}
      </SyntaxHighlighter>
    </div>



    <p>monokaiSublime</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={monokaiSublime}>
        {jsonString}
      </SyntaxHighlighter>
    </div>

    <p>solarizedLight</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={solarizedLight}>
        {jsonString}
      </SyntaxHighlighter>
    </div>


    <p>dracula</p>
<div>
      <h1>JSON Example</h1>
      <SyntaxHighlighter language="javascript" style={dracula}>
        {jsonString}
      </SyntaxHighlighter>
    </div>


    </div>
  );
};

export default App;